const SELECTORS = {
  productContainer: Utility.DomSelector.$('[data-product-container]')
};

class TemplateProductJS {
  constructor() {
    this.container = SELECTORS.productContainer;

    this.init();
  }

  init(){
    // Dynamic section updates (SKU, inventory, quantity, volume pricing) are handled
    // by ProductForm.updateDynamicSections, scoped per container for both PDP and cards
    this.initSubmitOfferButtonText();
    this.initOfferlyModalScrollLock();
    this.initOfferInputFieldsBorderState();
  }

  initSubmitOfferButtonText() {
    const OFFER_SUBTITLE_SELECTOR = '.offerly-modal-subtitle[data-offerly-theme-subtitle]';
    const OFFER_SUBTITLE_TEXT = "Submit your best offer for this product and we'll get back to you soon!";

    const updateOfferlyModalContent = () => {
      const submitOfferButton = document.querySelector('#submitOfferButton');
      if (submitOfferButton) {
        submitOfferButton.innerText = 'submit offer';
      }

      const modalHeader = document.querySelector('#offerlyModalHeader');
      if (!modalHeader) return;

      let subtitle = modalHeader.parentElement?.querySelector(OFFER_SUBTITLE_SELECTOR);
      if (!subtitle) {
        subtitle = document.createElement('p');
        subtitle.className = 'offerly-modal-subtitle';
        subtitle.setAttribute('data-offerly-theme-subtitle', '');
        modalHeader.insertAdjacentElement('afterend', subtitle);
      }

      subtitle.textContent = OFFER_SUBTITLE_TEXT;
    };

    document.addEventListener('DOMContentLoaded', () => {
      updateOfferlyModalContent();
      document.addEventListener('click', updateOfferlyModalContent);
    });
  }

  // Mirror the theme's body scroll-lock (`scroll-fixed`) when the third-party
  // Offerly modal (#OfferlyModalDiv) is open. The modal is injected and toggled
  // by the Offerly app, so we observe its visibility instead of binding events.
  initOfferlyModalScrollLock() {
    const MODAL_ID = 'OfferlyModalDiv';
    const SCROLL_LOCK_CLASS = 'scroll-fixed';

    const isModalOpen = (modal) => {
      if (!modal) return false;
      const style = window.getComputedStyle(modal);
      return style.display !== 'none' && style.visibility !== 'hidden';
    };

    const syncBodyClass = (modal) => {
      if (isModalOpen(modal)) {
        document.body.classList.add(SCROLL_LOCK_CLASS);
      } else {
        document.body.classList.remove(SCROLL_LOCK_CLASS);
      }
    };

    let modalObserver = null;

    const watchModal = (modal) => {
      if (!modal || modalObserver) return;
      modalObserver = new MutationObserver(() => syncBodyClass(modal));
      modalObserver.observe(modal, {
        attributes: true,
        attributeFilter: ['style', 'class', 'aria-hidden', 'hidden']
      });
      syncBodyClass(modal);
    };

    const existing = document.getElementById(MODAL_ID);
    if (existing) {
      watchModal(existing);
      return;
    }

    const bodyObserver = new MutationObserver(() => {
      const modal = document.getElementById(MODAL_ID);
      if (modal) {
        watchModal(modal);
        bodyObserver.disconnect();
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  initOfferInputFieldsBorderState() {
    const CONTAINER_SELECTOR = '#offerInputFields';
    const FIELD_SELECTOR = 'input, textarea, select';
    let containerObserver = null;

    const updateFieldState = (field) => {
      field.classList.toggle('is-filled', field.value.trim() !== '');
    };

    const bindFields = (container) => {
      container.querySelectorAll(FIELD_SELECTOR).forEach((field) => {
        updateFieldState(field);
        if (field.dataset.offerFieldBound) return;
        field.dataset.offerFieldBound = 'true';
        field.addEventListener('input', () => updateFieldState(field));
        field.addEventListener('change', () => updateFieldState(field));
      });
    };

    const watchContainer = (container) => {
      bindFields(container);
      if (containerObserver) return;
      containerObserver = new MutationObserver(() => bindFields(container));
      containerObserver.observe(container, { childList: true, subtree: true });
    };

    const tryInit = () => {
      const container = document.querySelector(CONTAINER_SELECTOR);
      if (container) watchContainer(container);
    };

    document.addEventListener('DOMContentLoaded', tryInit);
    document.addEventListener('click', tryInit);

    const bodyObserver = new MutationObserver(tryInit);
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }
}

new TemplateProductJS();